/**
 * App Events Store
 * Replaces the window CustomEvent bus with reactive Pinia state.
 * Components watch the reactive timestamps to react to events.
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppEventsStore = defineStore('app-events', () => {
  /** Incremented when a 401 response is received — watchers trigger logout */
  const unauthorizedAt = ref(0)

  /** Incremented when a BCU-consuming API call completes — watchers refresh balance */
  const bcuChangedAt = ref(0)

  /** Set when a deep component requests opening the context generation modal */
  const openContextModalAt = ref(0)

  /** Set when a deep component requests opening the AI Review Settings tab */
  const openAiReviewSettingsAt = ref(0)

  function emitUnauthorized() {
    unauthorizedAt.value = Date.now()
  }

  function emitBcuChanged() {
    bcuChangedAt.value = Date.now()
  }

  function emitOpenContextModal() {
    openContextModalAt.value = Date.now()
  }

  function emitOpenAiReviewSettings() {
    openAiReviewSettingsAt.value = Date.now()
  }

  return {
    unauthorizedAt,
    bcuChangedAt,
    openContextModalAt,
    openAiReviewSettingsAt,
    emitUnauthorized,
    emitBcuChanged,
    emitOpenContextModal,
    emitOpenAiReviewSettings,
  }
})
